module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/row-events/row-events.component.css
// module id = ./src/app/examples/row-events/row-events.component.css
// module chunks = main